'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = ['M102.2 348.1c2.2 8.3 6.9 16.5 13.9 25.1L325.6 163.8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-37.6 37.6 125.5 0c4-10.3 7.8-20.7 11.2-31.1 19.7-59.9 29.4-119 32.7-158.7 0 0 0-.2-.1-.4-.1-.3-.3-.6-.7-1s-.7-.6-1-.7c-.2-.1-.4-.1-.4-.1-39.7 3.3-98.8 12.9-158.7 32.7-60.2 19.9-118.5 49-159.1 89.6-70.2 70.3-70.1 148.2-57.8 193.8zm36.5 47.8c8.6 7 16.8 11.7 25.2 13.9 45.7 12.3 123.6 12.5 193.8-57.8l-175.1 0-43.9 43.8zM214.6 320L385 320c14.2-19.4 26.6-41.1 37.4-64l-143.8 0-64 64z', 'M475.3 .1c9.9-.8 19.6 3 26.6 10s10.8 16.7 10 26.6l-1.6 16.6c-9.7 87.2-44.5 235.8-129.9 321.3l-7.5 7.3c-73.1 68.1-153.7 72.6-206.7 61.3l-10.6-2.5c-14.8-4-27.8-12.2-39.6-22.1L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l88.7-88.8c-8.2-9.7-15.3-20.3-19.7-32.2l-2.4-7.3C57.2 304 57.3 217.3 130.1 139.2l7.3-7.5C222.8 46.2 371.5 11.4 458.7 1.7L475.3 .1zM182.6 352l-43.9 43.8c8.6 7 16.8 11.7 25.2 13.9 45.7 12.3 123.6 12.5 193.8-57.8l-175.1 0zM477.9 32c-39.7 3.3-98.8 12.9-158.7 32.7-60.2 19.9-118.5 49-159.1 89.6-70.2 70.3-70.1 148.2-57.8 193.8 2.2 8.3 6.9 16.5 13.9 25.1L325.6 163.8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-37.6 37.6 125.5 0c4-10.3 7.8-20.7 11.2-31.1 19.7-59.9 29.4-119 32.7-158.7 0 0 0-.2-.1-.4-.1-.3-.3-.6-.7-1s-.7-.6-1-.7c-.2-.1-.4-.1-.4-.1zM278.6 256l-64 64 170.3 0c14.2-19.4 26.6-41.1 37.4-64l-143.8 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;